var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"about-container",attrs:{"v-loading":_vm.loading||!_vm.srcLoaded}},[_c('iframe',{staticClass:"about-content",attrs:{"src":_vm.src,"frameborder":"0"},on:{"load":function($event){_vm.srcLoaded=true}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }